import React from 'react'

function CTA () {
  return (
    <div className="cta">
        <a href="resume.pdf" className="btn" download='Sarun M.pdf'>
           Cv Download
        </a>

       
    </div>
  )
}

export default CTA
